import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-file",
  templateUrl: "./med-icon-file.component.html",
})
export class MedIconFileComponent extends SvgMixinComponent {}
